var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('Search',{attrs:{"catId":_vm.catId},on:{"getCatId":_vm.getCatId}}),_c('div',{staticClass:"content"},[_c('Brands',{attrs:{"brands":_vm.brands,"brandId":_vm.brandId},on:{"getBrandId":_vm.getBrandId}}),_c('Product',{attrs:{"products":_vm.results},on:{"getMoreProductList":_vm.getMoreProductList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }